import { createPath } from 'react-router';

import {
	firstValue,
	pathHasPrefix,
	useDispatchNavAction,
} from '@adflow/frontend/util-router';
import type { ViewAuthUserDto } from '@adflow/shared/util-users';

const loginPagePath = '/login';
const defaultReturnUrl = '/';

function isOnLoginPage(location: { pathname: string }) {
	return pathHasPrefix(location.pathname, loginPagePath);
}

interface RedirectFromLoginOptions {
	/**
	 * Prevent the login page from returning the user to the URL they where at
	 * when they logged out.
	 */
	noReturn?: boolean;
}

export function useRedirectToLogin() {
	const dispatchNavAction = useDispatchNavAction();

	return ({ noReturn = false }: RedirectFromLoginOptions = {}) =>
		dispatchNavAction((location) => {
			if (isOnLoginPage(location)) return;

			const r = createPath(location);

			return {
				pathname: loginPagePath,
				search: noReturn || r === defaultReturnUrl ? undefined : { r },

				replace: true,
				state: {
					noBlockNavigation: true,
				},
			};
		});
}

export function useRedirectFromLogin(_user: ViewAuthUserDto | null) {
	// const ability = useMemo<permissionSystem.Ability>(
	// 	() => defineAbilityFor(user),
	// 	[user]
	// );

	const dispatchNavAction = useDispatchNavAction();

	return () =>
		dispatchNavAction((location) => {
			if (!isOnLoginPage(location)) return;

			// TODO: Prevent return url from not starting with /admin on admin.
			if (firstValue(location.parsedSearch.r)) {
				return firstValue(location.parsedSearch.r);
			}

			// if (ability.can('view', 'Dashboard')) return defaultReturnUrl;

			return defaultReturnUrl;
		});
}

export function useRedirectFromWelcomePage() {
	const dispatchNavAction = useDispatchNavAction();

	return () =>
		dispatchNavAction((location) => {
			if (location.pathname === defaultReturnUrl) return;

			return defaultReturnUrl;
		});
}
